import { applyNumberValidation } from "../shared.ts";
import type { RenderContext, RenderField } from "../types.ts";
import { renderTextLikeField } from "./text-input.ts";

export const renderNumberField = (
  field: RenderField<"NUMBER">,
  context: RenderContext,
): HTMLElement => {
  const rules = field.validationJson;

  return renderTextLikeField(field, context, "number", (input) => {
    applyNumberValidation(input, rules);
  });
};
